import clsx from 'clsx'
import { useCallback, useMemo } from 'react'

export function MultiNumberSelect({
  value,
  onChange,
  type
}: {
  value?: number[] | null
  onChange: (value: number[]) => void
  type: 'days' | 'months'
}) {
  const currentItems = useMemo(() => value ?? [], [value])

  const items = useMemo(() => {
    const length = type === 'days' ? 31 : 12

    return Array.from({ length }, (_, i) => i + 1)
  }, [type])

  const onToggle = useCallback(
    (select: boolean, day: number) => {
      const newValue = select
        ? [...currentItems, day]
        : currentItems.filter(d => d !== day)

      onChange(newValue.toSorted((a, b) => a - b))
    },
    [currentItems, onChange]
  )

  return (
    <div className="flex select-none flex-row items-center gap-1 rounded-small border border-text bg-white py-1.5 pl-2 pr-3">
      <div
        className={clsx(
          'grid w-full gap-2',
          type === 'days' && 'grid-cols-7',
          type === 'months' && 'grid-cols-6'
        )}
      >
        {items.map(function (item) {
          const isSelected = currentItems.includes(item)

          return (
            <button
              key={item}
              onClick={() => onToggle(!isSelected, item)}
              tabIndex={0}
              className={clsx(
                'size-8 rounded-small text-center',
                isSelected && 'bg-primary-bright'
              )}
            >
              {item}
            </button>
          )
        })}
      </div>
    </div>
  )
}
